import * as S from './'

type GroupIconProps = {
  color: string
  actived?: boolean
  size?: number
}

const GroupIcon = ({ color, actived, size }: GroupIconProps) => (
  <S.GroupIconWrapper color={color} actived={actived} size={size}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49147 10.5572C7.7499 10.5572 8.77005 9.53701 8.77005 8.27858C8.77005 7.02016 7.7499 6 6.49147 6C5.23305 6 4.21289 7.02016 4.21289 8.27858C4.21289 9.53701 5.23305 10.5572 6.49147 10.5572Z"
        fill={color}
      />
      <path
        d="M9.39324 12.3294C8.96479 11.6283 8.20526 11.1609 7.32888 11.1609H5.63455C4.40762 11.1609 3.37544 12.0762 3.23912 13.2837L3.00542 15.2701C2.96647 15.5233 3.14174 15.757 3.39492 15.8154C4.36867 16.0297 5.40085 16.127 6.49145 16.127C7.03675 16.127 7.56258 16.1076 8.08841 16.0491L8.30263 14.3548C8.40001 13.5563 8.80898 12.8357 9.39324 12.3294Z"
        fill={color}
      />
      <path
        d="M18.0206 10.5572C19.2791 10.5572 20.2992 9.53701 20.2992 8.27858C20.2992 7.02016 19.2791 6 18.0206 6C16.7622 6 15.7421 7.02016 15.7421 8.27858C15.7421 9.53701 16.7622 10.5572 18.0206 10.5572Z"
        fill={color}
      />
      <path
        d="M21.273 13.3032C21.1367 12.0957 20.1045 11.1804 18.8776 11.1804H17.1833C16.3069 11.1804 15.5473 11.6478 15.1189 12.3489C15.7226 12.8358 16.1316 13.5564 16.229 14.3743L16.4432 16.0687C16.969 16.1271 17.4949 16.1466 18.0402 16.1466C19.1113 16.1466 20.1629 16.0297 21.1367 15.835C21.3899 15.7765 21.5457 15.5428 21.5262 15.2897L21.273 13.3032Z"
        fill={color}
      />
      <path
        d="M13.0935 12.3293H11.3992C10.1723 12.3293 9.14009 13.2447 9.00377 14.4521L8.77007 16.4191C8.73112 16.6723 8.90639 16.9255 9.15957 16.9644C10.1333 17.1786 11.185 17.276 12.2561 17.276C13.3272 17.276 14.3789 17.1592 15.3526 16.9644C15.6058 16.906 15.7616 16.6723 15.7421 16.4191L15.5084 14.4521C15.3526 13.2447 14.3205 12.3293 13.0935 12.3293Z"
        fill={color}
      />
      <path
        d="M12.2561 11.7062C13.5145 11.7062 14.5347 10.6861 14.5347 9.42763C14.5347 8.1692 13.5145 7.14905 12.2561 7.14905C10.9977 7.14905 9.97754 8.1692 9.97754 9.42763C9.97754 10.6861 10.9977 11.7062 12.2561 11.7062Z"
        fill={color}
      />
    </svg>
  </S.GroupIconWrapper>
)

export default GroupIcon
